'use-client';
import * as React from 'react';
import type {
  IDropDownMenuProps,
  IDropDownMenuImperativeActions,
} from '../../../DropDownMenu.types';
import MenuButton from '../../../../MenuButton/viewer/skinComps/SeparateShinyIIMenuButtonNSkin/SeparateShinyIIMenuButtonNSkin';
import SeparateShinyIIMenuButton from './SeparateShinyIIMenuButton';
import styles from './SeparateShinyIIMenuButtonSkin.scss';

const SeparateShinyIIMenuButtonSkin: React.ForwardRefRenderFunction<
  IDropDownMenuImperativeActions,
  IDropDownMenuProps
> = (props, ref) => {
  return (
    <SeparateShinyIIMenuButton
      {...props}
      ref={ref}
      styles={styles}
      Button={MenuButton}
    />
  );
};

export default React.forwardRef(SeparateShinyIIMenuButtonSkin);
